var Actions;
(function (Actions) {
    Actions["INIT_MASTER_COMPETENCY_MAPPING_LIST"] = "getInitMasterCompetencyMappingListAction";
    Actions["GET_MASTER_COMPETENCY_MAPPING_LIST"] = "getAllMasterCompetencyMappingList";
    Actions["HANDLE_CURRENT_PAGE_CHANGE"] = "handleMasterCompetencyMappingListPageChange";
    Actions["HANDLE_CURRENT_PAGE_CHANGE_ON_SORT"] = "handleMasterCompetencyMappingListPageChangeOnSort";
    Actions["RESET_FILTERS"] = "resetMasterCompetencyMappingListFilters";
    Actions["DELETE_LIST"] = "handleMasterCompetencyMappingListDelete";
    // filter options
    Actions["HANDLE_SORT_CHANGE"] = "handleMasterCompetencyMappingListSortChange";
    Actions["DOWNLOAD_COMPETENCY_MAPPING"] = "handleDownloadMasterCompetencyMapping";
    Actions["EXPORT_COMPETENCY_MAPPING"] = "handleExportMasterCompetencyMapping";
    // post data
    Actions["POST_DATA"] = "postMasterCompetencyMappingData";
    Actions["UPDATE_DATA"] = "updateMasterCompetencyMappingData";
    Actions["GET_SCHEMES_OPTIONS"] = "getAllSchemesOptionsList";
    Actions["GET_JABATANS_OPTIONS"] = "getAllJabatansOptionsList";
    Actions["GET_MASTER_COMPETENCY_MAPPING_LIST_DETAIL"] = "getMasterCompetencyMappingListDetail";
    Actions["UPLOAD_CHANGE_COMPETENCY_MAPPING"] = "handleUploadChangeCompetencyMapping";
    Actions["UPLOAD_CREATE_COMPETENCY_MAPPING"] = "handleUploadCreateCompetencyMapping";
    Actions["UPLOAD_SUBMIT_CHANGE_COMPETENCY_MAPPING"] = "handleSubmitChangeCompetencyMapping";
    Actions["UPLOAD_SUBMIT_CREATE_COMPETENCY_MAPPING"] = "handleSubmitCreateCompetencyMapping";
})(Actions || (Actions = {}));
var Mutations;
(function (Mutations) {
    Mutations["SET_INIT_MASTER_COMPETENCY_MAPPING_LIST"] = "setInitMasterCompetencyMappingList";
    Mutations["SET_MASTER_COMPETENCY_MAPPING_LIST"] = "setMasterCompetencyMappingList";
    Mutations["SET_LOADING"] = "setMasterCompetencyMappingListLoading";
    Mutations["SET_MODAL_LOADING"] = "setMasterCompetencyMappingModalFilterLoading";
    Mutations["SET_PAGINATION_LOADING"] = "setMasterCompetencyMappingListPaginationLoading";
    Mutations["SET_PAGINATION_CURRENT_PAGE_CHANGE"] = "setMasterCompetencyMappingListCurrentPageChange";
    Mutations["SET_DISPLAYED_RECORDS"] = "setMasterCompetencyMappingListDisplayRecords";
    Mutations["SET_ORDERED_MASTER_COMPETENCY_MAPPING_LIST"] = "setOrderedMasterCompetencyMappingList";
    Mutations["SET_FILTERED_MASTER_COMPETENCY_MAPPING_LIST"] = "setFilteredMasterCompetencyMappingList";
    Mutations["SET_IS_FILTER"] = "setMasterCompetencyMappingListIsFilter";
    Mutations["RESET_MASTER_COMPETENCY_MAPPING_LIST_FILTER"] = "resetMasterCompetencyMappingListFilter";
    Mutations["SET_LAST_ORDER_PROP"] = "setMasterCompetencyMappingListLastOrderProp";
    Mutations["SET_PAGINATION_TOTAL_PAGE"] = "setMasterCompetencyMappingListPaginationTotalPage";
    Mutations["SET_FILTER"] = "setMasterCompetencyMappingFilterParams";
    Mutations["SET_SCHEMES_OPTIONS"] = "setMasterCompetencyMappingSchemesOptionsList";
    Mutations["SET_JABATANS_OPTIONS"] = "setMasterCompetencyMappingJabatansOptionsList";
    Mutations["SET_MANDATORY_IN_FORM_OPTIONS"] = "setMasterCompetencyMappingPostMandatoryInFormOptions";
    Mutations["SET_MASTER_COMPETENCY_MAPPING_LIST_DETAIL"] = "setMasterCompetencyMappingListDetail";
    Mutations["SET_EDIT_LIST"] = "setMasterCompetencyMappingEditList";
    // set data from row
    Mutations["SET_MASTER_QUESTION_CODE_DATA_FROM_RECORD_GRID"] = "setMasterCompetencyMappingDataFromRecordGrid";
    // set loading
    Mutations["SET_UPLOAD_LOADING"] = "setMasterCompetencyMappingPostUploadLoading";
    // clear form input
    Mutations["CLEAR_FORM_INPUT"] = "clearMasterCompetencyMappingFormInput";
    Mutations["SET_ORDER"] = "setMasterCompetencyMappingOrderBy";
})(Mutations || (Mutations = {}));
export { Actions, Mutations };
